<template>
  <div>
    <new-post-box
      v-if="(group.id == 217 && (auth.is_admin || ['O', 'A', 'M'].indexOf(group.memberRole) > -1)) || (group.id != 217 && ['O', 'A', 'M'].indexOf(group.memberRole) > -1)"
      :group_id="group.id"
      :onSharePostSuccess="onSharePostSuccess"
      :post_types="post_types"
    ></new-post-box>

    <div v-if="(['PUBLIC', 'COURSE'].indexOf(group.type) > -1 && (isEmpty(group.memberRole) || group.memberRole == 'GUEST')) && !loading_join_group" class="box is-boxed-3">
      <edlorders-buy v-if="!isEmpty(group.groupPrice) && isEmpty(group.userInvoiceInGroup)" :group="group" :onBuySuccess="getGroup"></edlorders-buy>
      <edloders-waiting-payment v-else-if="!isEmpty(group.groupPrice) && !isEmpty(group.userInvoiceInGroup)"
        :groupId="group.id"
        :userInvoiceInGroup="group.userInvoiceInGroup"
        :onAlreadyPaySuccess="getGroup"
        :onCancelProcessSuccess="getGroup">
      </edloders-waiting-payment>

      <empty-data v-else>
        <p class="font-20 font-w-500" style="margin-bottom: 30px;">Anda belum tergabung di kelas ini.</p>

        <button class="button is-secondary font-20 font-w-600" style="border-radius: 8px;"
          @click.prevent="join($route.params.id)"
          :class="{'is-loading': loading_join_group}"
          :disabled="loading_join_group">
          Gabung
        </button>
      </empty-data>
    </div>
    <div class="is-boxed" v-else-if="loading_join_group">
      <spinner-loading></spinner-loading>
    </div>
    <div v-else-if="!loading_get_posts_refresh && posts.length > 0" :class="is_edit ? 'is-disabled' : ''">
      <greeting-box v-if="group.type == 'COURSE'" :groupProgress="progress" :group="group"></greeting-box>

      <!-- START POST TYPE -->
      <post-item v-for="(post, index) in posts"
        :key="index"
        :group="post.group"
        :post="post"
        :user="post.user"
        :selectMedia="selectMedia"
        @getPosts="getPosts"
        :editPost="editPost"
        :setPosts="setPosts"
        :setPostsDataProvider="setPostsDataProvider"
        :showCommentLists="true"
        :embed="embed" />

      <pagination v-if="!loading_get_posts" :dataProvider="dataProvider" :clickHandler="getPosts" :infinity_scroll="true"></pagination>

      <div v-if="loading_get_posts">
        <spinner-loading></spinner-loading>
      </div>

      <!-- Edit Post -->
      <edit-post-box v-if="!isEmpty(selected_post)" :postData="selected_post" :onSharePostSuccess="onSharePostSuccess"></edit-post-box>
    </div>

    <div class="box" v-if="(!loading_join_group && !loading_get_posts && !loading_get_posts_refresh) && (((!isEmpty(group.memberRole) && (['ACADEMIC', 'PRIVATE', 'PUBLIC', 'COURSE'].indexOf(group.type) > -1 && group.memberRole != 'GUEST')) || loading_join_group) || (group.type == 'ACADEMIC' && !isEmpty(pt) && pt.type == 'ADMIN' && pt.university_id == group.university_id)) && posts.length <= 0">
      <empty-data >
        <p class="font-20" style="margin-bottom: 30px;">Belum ada postingan.</p>
      </empty-data>
    </div>

    <div v-if="loading_get_posts_refresh">
      <spinner-loading></spinner-loading>
    </div>
  </div>
</template>

<script>
import Post from '~/components/Post';
import { mapState, mapMutations, mapActions } from 'vuex';
import CLASSMATE_MIXIN from '~/mixins/classmate'
import NewPostBox from '~/components/molecules/NewPostBox';
import EditPostBox from '~/components/molecules/EditPostBox';
import GreetingBox from '~/components/molecules/GreetingBox';
import PostItem from '~/components/molecules/posts/PostItem';

export default {
  mixins: [CLASSMATE_MIXIN],

  components: {
    Post,
    NewPostBox,
    EditPostBox,
    GreetingBox,
    PostItem
  },

  props: [
    'group',
    'onLearningMaterialAdded',
    'onLearningMaterialFailAdd',
    'embed',
    'getGroup',
    'progress',
  ],

  mounted() {
    if (!((['PUBLIC', 'COURSE'].indexOf(this.group.type) > -1 && (this.isEmpty(this.group.memberRole) || this.group.memberRole == 'GUEST')) && !this.loading_join_group)) {
      this.init();
    }
  },

  destroyed() {
    // window.Echo.leaveChannel(`private-new-group-post-${this.group.id}`);
  },

  computed: {
    ...mapState({
      auth: state => state.auth,
      pt: state => !helpers.isEmpty(state.auth) && state.auth.active_pt ? state.auth.active_pt : null,
      show_add_box: state => state.posts.show_add_box
    }),
    canAddConference() {
      return !this.isEmpty(this.auth.activeAccount) && this.auth.activeAccount.permissionNames.includes("add_conference_learning_material") === true;
    },
    canIntegrateZoomInAcademicClass() {
      return !this.isEmpty(this.auth.activeAccount) && this.auth.activeAccount.permissionNames.includes("can_integrate_zoom_academic_class") === true;
    },
    canIntegrateZoomInGeneralClass() {
      return !this.isEmpty(this.auth.activeAccount) && this.auth.activeAccount.permissionNames.includes("can_integrate_zoom_general_class") === true;
    },
    post_types() {
      let types = ['M', 'Q', 'Z', 'I', 'S', 'E']

      if (
        !this.isEmpty(this.auth) &&
        !this.isEmpty(this.auth.activeAccount) &&
        this.auth.activeAccount.type != 'STUDENT' &&
        (this.canAddConference || this.canIntegrateZoomInAcademicClass || this.canIntegrateZoomInGeneralClass)
      ) {
        if ((this.canAddConference || this.canIntegrateZoomInAcademicClass) && this.group.type == 'ACADEMIC') {
          types.push("V");
        } else if ((this.canAddConference || this.canIntegrateZoomInGeneralClass) && ['PRIVATE', 'PUBLIC'].includes(this.group.type) === true) {
          types.push("V");
        }
      }

      if (['M'].indexOf(this.group.memberRole) > -1) {
        types = ['I', 'S', 'E']
      }

      if (['O', 'A', 'M'].indexOf(this.group.memberRole) <= -1) {
        types = []
      }

      return types
    }
  },

  data() {
    return {
      loading_get_posts: false,
      loading_get_posts_refresh: false,
      selected_media: null,
      is_edit: false,
      posts: [],
      selected_post: null,
      dataProvider: {
        criterion: [
          {
            operator: 'EQ',
            value: '',
            criteria: 'type'
          }, {
            operator: 'LK',
            value: '',
            criteria: 'title,description'
          }
        ],
        page: {
          count: 0,
          current: this.$route.query.page !== undefined ? this.$route.query.page : 1,
          limit: 0,
          next: 2,
          previous: 1,
          total: 0
        },
        sort: []
      },
      medias: []
    }
  },

  methods: {
    ...mapActions({
      fetchPosts: 'posts/getAll',
    }),
    init() {
      const vm = this;
      this.getPosts(true);

      // window.Echo.private(`new-group-post-${this.group.id}`)
      //   .listen('NewGroupPostEvent', (e) => {
      //     if (this.auth.id != e.data.user_id) {
      //       snackbar.default(e.data.title, {
      //         actionText: 'Lihat',
      //         onAction: () => {
      //           vm.getPosts(true);
      //         }
      //       })
      //     }
      //   })
    },
    async getPosts(refresh = false) {
      const vm = this;
      const id = vm.group.id;

      if (refresh) {
        this.dataProvider.page.current = 1;
        vm.loading_get_posts_refresh = true
      } else {
        vm.loading_get_posts = true;
      }

      let { data } = await vm.fetchPosts({groupId: id, dataProvider: JSON.stringify(this.dataProvider)});

      if (data.applicationSystem.code == 0) {
        let posts = collect(vm.posts);

        if (!refresh) {
          let post_ids = posts.pluck('id').toArray();
          posts = posts.toArray().concat(collect(data.data.data).filter((p) => {
            if (post_ids.indexOf(p.id) > -1) {
              return false;
            }

            return true;
          }).toArray());
        } else {
          posts = data.data.data;
        }

        Vue.nextTick(() => {
          vm.setPosts(collect(posts).toArray());
          vm.setPostsDataProvider(data.data.dataProvider);
        })
      }

      if (refresh) {
        vm.loading_get_posts_refresh = false
      } else {
        vm.loading_get_posts = false;
      }
    },
    setPosts(posts) {
      this.posts = posts;
      this.selected_post = null
    },
    setPostsDataProvider(dataProvider) {
      this.dataProvider = dataProvider;
    },
    afterSave(data, postData) {
      const vm = this;

      if (data.applicationSystem.code == 0) {
        this.$buefy.toast.open({
          type: 'is-success',
          message: data.applicationSystem.message
        });

        vm.resetPost();
        vm.getPosts(true);
      } else {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: data.applicationSystem.message
        });
      }

      vm.loading_save = false;
      vm.is_edit = false;
      this.toggleBox(false);
    },
    refreshPosts() {
      this.getPosts(true);
    },
    selectMedia(media) {
      if (['document', 'link'].indexOf(media.type) > -1) {
        if (media.type == 'link' && !this.isEmpty(media.link)) {
          window.open(media.link,'_blank');
        } else if ( media.type == "document" && media.storageType == 'google_drive' && !this.isEmpty(media.values) ) {
          window.open(media.values.webViewLink, "_blank");
        } else if (media.type == 'document' && !this.isEmpty(media.file) && !this.isEmpty(media.file.link)) {
          this.openDocument(media.file.link);
        }
      }
    },
    onSharePostSuccess() {
      this.getPosts(true)
    },
    editPost(post) {
      this.selected_post = this.transformKeysTo(post)
    },
    onJoinSuccess(res) {
      toast.default(res.applicationSystem.message)
      this.getGroup();

      Vue.nextTick(() => {
        this.init();
      })
    }
  },
}
</script>

<style scoped>
#box_manager {
  border: none !important;
}
.file-attachment {
  margin: 7px 0 !important;
}
.btn-submit {
  border: none;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.btn-cancel {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>
